<template>
  <el-radio-group
    ref="radioGroup"
    v-model="selectValue"
    :disabled="computedDisabled"
    :border-size="borderSize"
    :button-size="buttonSize"
    v-bind="$attrs"
    :class="computedClass"
    @change="handleChange"
    @input="handleInput"
  >
    <slot />
  </el-radio-group>
</template>

<script>
import ElRadioGroup from 'vue-xpc/src/element-ui/packages/radio/src/radio-group.vue';
export default {
  name: 'RtRadioGroup',
  components: { ElRadioGroup },
  props: {
    value: [String, Number, Boolean],
    disabled: {
      type: Boolean,
      default: false
    },
    // 带边框单选尺寸，默认medium，可选值small、medium、large
    borderSize: {
      type: String,
      default: 'medium'
    },
    // 按钮用法单选尺寸，默认medium，可选值small、medium、large
    buttonSize: {
      type: String,
      default: 'medium'
    }
  },
  data () {
    return {
      selectValue: this.value,
      radioType: 'round'
    };
  },
  inject: {
    elForm: {
      default: ''
    }
  },
  computed: {
    computedClass () {
      let classList = ['rt-radio-group'];
      if (this.borderSize) {
        classList.push(`rt-xpc-radio-bordered-${this.borderSize}`);
      }
      if (this.buttonSize) {
        classList.push(`rt-xpc-radio-button-${this.buttonSize}`);
      }
      if (this.radioType) {
        classList.push(`rt-xpc-radio-type-${this.radioType}`);
      }
      return classList;
    },
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  watch: {
    value (val) {
      this.selectValue = val;
    }
  },
  mounted () {
    let className =
      this.$refs.radioGroup &&
      this.$refs.radioGroup.$children &&
      this.$refs.radioGroup.$children[0] &&
      this.$refs.radioGroup.$children[0].$el.className;

    if (className.includes('is-bordered')) {
      this.radioType = 'border';
    } else if (className.includes('el-radio-button')) {
      this.radioType = 'button';
    } else {
      this.radioType = 'round';
    }
  },
  methods: {
    handleChange (val) {
      this.$emit('change', val);
    },
    handleInput (val) {
      this.$emit('input', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtRadioGroup.vue?231fe4ee